import { useMemo } from "react"

import { Source } from "react-map-gl"

import { sanitizeData } from "@l2r-front/l2r-geodata"
import { useTranslation } from "@l2r-front/l2r-i18n"
import { useMapDispatchContext } from "@l2r-front/l2r-map"

import { I18N_NAMESPACE } from "../../constants/i18n"
import { IMAGE_COLLECTION_TYPE_STREETVIEW } from "../../constants/imageCollectionsTypes"
import { useImageCollectionStateContext } from "../../contexts/ImageCollectionContext"
import { useImageCollectionLayer } from "../../hooks/queries/imageCollection/useImageCollectionLayer"

export function ImageCollectionSource(props) {

    const {
        road,
        ...sourceProps
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)
    const { setError: setMapError } = useMapDispatchContext()
    const { imageCollection, imageLayerDisplayed, selectedImageCollectionType } = useImageCollectionStateContext()

    const { data } = useImageCollectionLayer(imageCollection, { linear_location_road: road }, {
        onError: () => setMapError(true),
        errorSnackbarMessage: t(I18N_NAMESPACE, "containers.imageCollectionLayer.error"),
    })

    // Need to copy id into properties because of that mapbox issue:
    // link:https://github.com/mapbox/mapbox-gl-js/issues/2716
    const sanitizedData = useMemo(() => {
        return sanitizeData(data)
    }, [data])

    if (!sanitizedData || !imageLayerDisplayed || selectedImageCollectionType === IMAGE_COLLECTION_TYPE_STREETVIEW) {
        return null
    }

    return (
        <Source {...sourceProps} type="geojson" data={sanitizedData} tolerance={.001} />
    )
}

ImageCollectionSource.propTypes = Source.propTypes
